import React from 'react';
import { withPendingAttributionsContainer } from '../../../containers/gamification2026';
import SaleTable from './SaleTable';
import ConfirmationModal from './ConfirmationModal';

const PendingSaleAttributions = (props) => {
  const {
    page,
    saleAttribution,
    users,
    selectedUser,
    pendingSaleAttributions,
    pendingPagination,
    isAttributionSelected,
    onUpdateSaleAttribution,
    onCancelSaleAttribution,
    onToggleAcceptModal,
    onPageChange,
    onOpenUpdate,
  } = props;

  return (
    <div className="contracts-layout-content">
      <SaleTable
        attributions={pendingSaleAttributions}
        users={users}
        onAccept={onToggleAcceptModal}
        onOpenUpdate={onOpenUpdate}
        pagination={pendingPagination}
        onPageChange={onPageChange}
        page={page}
      />

      <ConfirmationModal
        selected={isAttributionSelected}
        saleAttribution={saleAttribution}
        selectedUser={selectedUser}
        onUpdateSaleAttribution={onUpdateSaleAttribution}
        onCancelSaleAttribution={onCancelSaleAttribution}
      />
    </div>
  );
};

export default withPendingAttributionsContainer(PendingSaleAttributions);
